import { client } from '../client';
import {
  buildCollectorUserPatchJsonBody,
  type UpdateCollectorUserPayload,
} from './collectorUserEditPayload';
import { getCollectorUserById } from './getCollectorUserById';
import { normalizeCollectorUserResponse } from './normalizeCollectorUserResponse';
import { UserProfile } from './types/UserProfile';

export type { UpdateCollectorUserPayload } from './collectorUserEditPayload';

const isDev = process.env.NODE_ENV === 'development';

/**
 * **PATCH /collector/users/:user_id** — updates a patient/dependent the collector created
 * (`created_by_id` must match). Do not use for the signed-in collector’s own row (will 404 / fail enforcement).
 * For the collector’s own profile, use **PATCH /collector/me** (see `updateMe` with `collectorEditingSelf`).
 */
export const updateCollectorUser = async (
  user_id: number,
  payload: UpdateCollectorUserPayload,
): Promise<UserProfile> => {
  const body = buildCollectorUserPatchJsonBody(payload);

  if (isDev) {
    // Log payload only (no Authorization header in body).
    // eslint-disable-next-line no-console
    console.info('[updateCollectorUser] PATCH', `/collector/users/${user_id}`, body);
  }

  const { data } = await client.patch<UserProfile | undefined>(`/collector/users/${user_id}`, body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (data == null) {
    return getCollectorUserById(user_id);
  }
  return normalizeCollectorUserResponse(data);
};
